import * as React from 'react';
export const rivermarkSvg = React.forwardRef(function rivermarkSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00817A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.991 9.073c5.076 1.762-.318 1.716-2.116 2.852-3.605 2.27 6.402 5.34 9.39 12.032 0 0-1.716-2.67-4.677-4.613-3.532-2.443-6.81-4.205-6.774-5.821.082-3.533 9.054-2.198 4.177-4.45Z',
      fill: '#CDCCE2',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 6.031h6.647c1.79-.09 3.487.036 4.123.136.175.025.175.025 0 0-.636-.1-2.334-.227-4.123-.136-1.943.1-4.005.445-4.949 1.344-1.017.98 3.296.808 4.24 2.28.491.771-3.65 1.552-5.929 2.733V6.03H8Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.87 26H8v-9.998c2.415 3.27 5.358 9.135 2.87 9.998Zm8.563-19.597c.427.128.88.3 1.28.518 1.072.572 1.862 1.317 2.38 2.216a5.78 5.78 0 0 1 .762 2.87c0 .926-.2 1.77-.59 2.524-.39.753-.953 1.38-1.689 1.898a14.67 14.67 0 0 1 2.58 4.259c.644 1.616 1.07 3.387 1.28 5.303h-.255c.164-3.977-6.175-10.18-9.217-11.76-1.08-.563-1.753-.763-1.616-1.589.263-1.544 6.193-.7 4.976-2.597-1.126-1.753-8.264-2.307-5.83-3.142a12.645 12.645 0 0 1 4.613-.681 8.69 8.69 0 0 1 1.262.163c.158 0 .179.006.064.018Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.973 9.51c2.742 1.416-4.204.626-4.904 3.713-.599 2.652 1.09 4.114 2.625 5.403 3.07 2.616 3.786 2.625 4.513 3.36 0 0-1.67-.69-4.041-2.17-1.798-1.217-1.898-1.38-2.252-1.726-.817-.98-2.116-2.506-1.744-4.177.918-4.131 7.556-3.042 5.803-4.404Z',
      fill: '#CDCCE2',
    }),
  );
});
rivermarkSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rivermark = {
  category: 'brand',
  colorable: false,
  name: 'rivermark',
  svg: rivermarkSvg,
};
